import MUICheckbox, { CheckboxProps as MUICheckboxProps } from '@mui/material/Checkbox';

export type CheckboxProps = MUICheckboxProps & {
	/**
	 * When true, centers the component on the cross-axis of its flex parent.
	 */
	alignCenter?: boolean;
};

/**
 * A simple extension of Mui's Checkbox component. For most use cases (especially when using checkboxes in forms) use the `LabeledCheckbox`component.
 * When using this atom as part of a bigger component, it is important to consider accessibility, including the correct labelling of the input element.
 */
export const Checkbox = ({ alignCenter, ...props }: CheckboxProps) => {
	return <MUICheckbox style={{ alignSelf: alignCenter ? 'center' : undefined }} {...props} />;
};
